// src/observations/store/actions/observations.actions.js
import { services } from '../../../../api/feathers';

export const GET_ACCOUNTCONTACTS = 'GET_ACCOUNT_CONTACTS';
export const GET_ACCOUNT_CONTACT = 'GET_ACCOUNT_CONTACT';
export const ADD_ACCOUNT_CONTACT = 'ADD_ACCOUNT_CONTACT';
export const UPDATE_ACCOUNT_CONTACT = 'UPDATE_ACCOUNT_CONTACT';
export const REMOVE_ACCOUNT_CONTACT = 'REMOVE_ACCOUNT_CONTACT';

// lista todas as accountContacts de um device
export function getAccountContacts(accountId) {
  return (dispatch) =>
    services.accountContacts
      .find({
        query: {
          accountId,
          $sort: { createdAt: 1 },
        },
      })
      .then((response) => {
        dispatch({ type: GET_ACCOUNTCONTACTS, payload: response.data });
        console.log('accountContacts', response.data);
      });
}

// busca uma única (se precisar)
export function getAccountContact(id) {
  return (dispatch) =>
    services.accountContacts.get(id).then((response) => {
      dispatch({ type: GET_ACCOUNT_CONTACT, payload: response });
      console.log('accountContact', response);
    });
}

// cria e recarrega a lista
export function addAccountContact(contact) {
  return (dispatch) =>
    services.accountContacts.create(contact).then((response) => {
      dispatch(getAccountContacts(contact.accountId));
      console.log('accountContact', response);
    });
}

// atualiza e recarrega a lista
export function updateAccountContact(id, contact) {
  return (dispatch) =>
    services.accountContacts
      .patch(id, contact)
      .then((response) =>
        dispatch({ type: UPDATE_ACCOUNT_CONTACT, payload: response })
      )
      .then(() => dispatch(getAccountContacts(contact.accountId)));
}

// remove sem recarregar
export function removeAccountContact(id) {
  return (dispatch) =>
    services.accountContacts
      .remove(id)
      .then((response) =>
        dispatch({ type: REMOVE_ACCOUNT_CONTACT, payload: response })
      );
}
